<template>
    <div>
		<img src="../assets/img/detail/cs/1.jpg" width="100%" />
		<img src="../assets/img/detail/cs/2.jpg" width="100%"/>
		<img src="../assets/img/detail/cs/3.jpg" width="100%"/>
		<img src="../assets/img/detail/cs/4.jpg" width="100%"/>
		<img src="../assets/img/detail/cs/5.jpg" width="100%"/>
		<img src="../assets/img/detail/cs/6.jpg" width="100%"/>
		<img src="../assets/img/detail/cs/7.jpg" width="100%"/>
		<img src="../assets/img/detail/cs/8.jpg" width="100%"/>
		<img src="../assets/img/detail/cs/9.jpg" width="100%"/>
		<img src="../assets/img/detail/cs/10.jpg" width="100%"/>
		<img src="../assets/img/detail/cs/11.jpg" width="100%"/>
		<img src="../assets/img/detail/cs/12.jpg" width="100%"/>
    </div>
</template>

<script>
    export default {
        name: 'Product_sswm',
        data: function () {
            return {
            }
        },
        mounted: function () {

        },
        created: function () {

        },
        methods: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/product_6_cs.vue